import React from "react";
import "../Navigation/css/NavBar.scss";
import {Black} from "../../theme/styles";
import ReactJson from 'react-json-view'
import bom002_1 from "../../json/bom/bom-002-1.json";
import bom002_2 from "../../json/bom/bom-002-2.json";


export default function BomsPut() {

    return (
        <div style={{paddingLeft: "20px", paddingRight: "30px"}}>
            <p style={{fontSize: "24px", fontWeight: "400", color: Black}}>Boms PUT</p>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>Overview</p>

            <p style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                In Enlil, a revision of a part may participate in bill of materials (BOM). Membership in a BOM is hierarchical with all parts (except the root part) having a parent and zero or more children.
            </p>
            <ul style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                <li style={{marginTop: "20px"}}>To upsert a BOM, the boms PUT API will enable an existing part to be related to another existing part (Insert) or update bom related data for a previously related pair of parts.</li>
            </ul>
            <br/>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>Parameters</p>
            <ul style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                <li style={{marginTop: "20px"}}>Header Parameters
                    <li style={{marginTop: "20px", marginLeft: "20px"}}>X-Enlil-AccessToken (Required String)</li>
                    <li style={{marginTop: "10px", marginLeft: "40px"}}>The X-Enlil-AccessToken is obtained during the authentication process and expires after 90 days.</li>
                    <li style={{marginTop: "20px", marginLeft: "20px"}}>X-Enlil-RefreshToken (Optional String)</li>
                    <li style={{marginTop: "10px", marginLeft: "40px"}}>The X-Enlil-RefreshToken is obtained during the authentication process and never expires. This token is provided is the caller wants a refreshed X-Enlil-AccessToken</li>
                    <li style={{marginTop: "20px", marginLeft: "20px"}}>idoc-response (Optional String: Default v1.Bom-001)</li>
                    <li style={{marginTop: "10px", marginLeft: "40px"}}>The name of the IDOC being requested.</li>
                </li>
                <li style={{marginTop: "20px"}}>Basic Query Parameters
                    <li style={{marginTop: "20px", marginLeft: "20px"}}>USID (Optional String)</li>
                    <li style={{marginTop: "10px", marginLeft: "40px"}}>The primary key of the bom entity</li>
                    <li style={{marginTop: "20px", marginLeft: "20px"}}>DocumentRevisionID (Optional String)</li>
                    <li style={{marginTop: "10px", marginLeft: "40px"}}>The USID of the part revision</li>
                </li>

            </ul>
            <br/>
            <span style={{textDecoration: "underline"}}><b>v1.Bom-002</b></span>
            <p style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                v1.Bom-002 is an IDOC designed to transact the BOM record for the parent and child part.
            </p>
            <p style={{fontSize: "12px", fontWeight: "400", color: Black, fontFamily: "Courier New"}}>
                <ReactJson src={bom002_1} collapseStringsAfterLength={75} collapsed={3}/>
            </p>
            <br/>
            <p style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                v1.Bom-002 allows for batch put actions as described in the payload below.
            </p>
            <p style={{fontSize: "12px", fontWeight: "400", color: Black, fontFamily: "Courier New"}}>
                <ReactJson src={bom002_2} collapseStringsAfterLength={75} collapsed={5}/>
            </p>
            <br/>
            <p style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                The parameters ParentDocumentRevisionUSID and ChildDocumentRevisionUSID represent a particular revision of a parent part and a particular revision of a child part. They must exist part to calling this API.
            </p>
        </div>
    )
}